<template>
  <!-- View more items modal template -->
  <b-modal ref="view-modal" hide-footer @hide="hideModal" id="modal-tabs">

    <template #modal-header="{ close }">
      <div class="text-center mt-4" style="width: 100%;">
        <span @click="hideModal" class="btn btn-secondary cursor-pointer float-right">
          <font-awesome-icon icon="times"/>
        </span>
        <h4 qid="update-tp-title" class="mb-2 ml-4 pl-4">
          <span v-if="type == 'tags'">
            {{ $t('system.view_all_tags') }}
          </span>
          <span v-if="type == 'users'">
            {{ $t('system.view_all_users') }}
          </span>
          <span v-if="type == 'organizations'">
            {{ $t('system.view_all_organizations') }}
          </span>
          <span v-if="type == 'countries' || type == 'countries_with_flag'">
            {{ $t('system.view_all_countries') }}
          </span>
          <span v-if="type == 'process_groups'">
            {{ $t('system.view_all_process_groups') }}
          </span>
          <span v-if="type == 'vendors'">
            {{ $t('system.view_all_vendors') }}
          </span>
        </h4>
      </div>
    </template>

    <div class="card-modern pr-6 pl-6">

      <div v-if="type == 'tags'">
        <div class="" v-for="tag in items" qid="modal-tags-list">
          <span class="badge mb-1">
            <font-awesome-icon icon="tag"/>
            {{ tag.name_translated }}
          </span>
        </div>
      </div>

      <div v-if="type == 'organizations'">
        <div class="" v-for="organization in items" qid="modal-organizations-list">
          <span class="badge mb-1">
            <font-awesome-icon icon="sitemap"/>
            {{organization.name}}
          </span>
        </div>
      </div>

      <div v-if="type == 'countries_with_flag'">
        <div v-if="object && object.vendor && object.vendor.country_with_flag" qid="modal-organizations-list">
          <span class="badge mb-1">
            <img v-bind:src="object.vendor.country_with_flag.flag" height="13" class="align-baseline mr-1" />
            {{ object.vendor.country_with_flag.name }}
          </span>
        </div>
        <div class="" v-for="country in items" qid="modal-organizations-list">
          <span class="badge mb-1">
            <img v-bind:src="country.flag" height="13" class="align-baseline mr-1" /> <span>{{country.name}}</span>
          </span>
        </div>
      </div>

      <div v-if="type == 'countries'">
        <div v-if="object && object.vendor && object.vendor.country" qid="modal-organizations-list">
          <span class="badge mb-1">
            {{ object.vendor.country }}
          </span>
        </div>
        <div class="" v-for="country in items" qid="modal-organizations-list">
          <span class="badge mb-1">
            {{country}}
          </span>
        </div>
      </div>

      <div v-if="type == 'process_groups'">
        <div class="" v-for="process_group in items" qid="modal-organizations-list">
          <span class="badge mb-1">
            <font-awesome-icon icon="project-diagram"/>
            {{process_group.name}}
          </span>
        </div>
      </div>

      <div v-if="type == 'users'">
        <span v-for="user in items" qid="modal-users-list">
          <Avatar :object="user" size="xs" class="mr-2"></Avatar>
          {{ user.name }}
          <br><br>
        </span>
      </div>

      <div v-if="type == 'vendors'">
        <span v-for="item in items" qid="modal-vendors-list">
          <Avatar :object="item" size="xs" class="mr-2"></Avatar>
          {{ item.name }}
          <br><br>
        </span>
      </div>

    </div>

    <br>

    <b-button class="mt-4 mb-4 mr-4 float-right"
              variant="secondary"
              @click="hideModal"
              qid="create-p-cancel-button"
    >
      {{ $t('processes.policies.view.close') }}
    </b-button>
    <br>

  </b-modal>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue'

  export default {
    name: 'ShowMoreModal',
    data: function() {
      return {
        error: '',
        processGroup: [],
        showInput: false,
        loadingItems: false,
        showArticleDescription: false
      }
    },
    props: {
      items: {
        type: Array
      },
      show: {
        type: Boolean
      },
      type: {},
      object: {}
    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      }
    },
    watch: {
      // Watch when prop changes
      show: function (value) {
        if (value) {
          this.showModal()
        }
      }
    },
    methods: {
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      showModal() {
        let self = this
        this.$refs['view-modal'].show()
      },
      hideModal() {
        this.error = ''
        this.showArticleDescription = false;
        this.$emit('closeViewModal');
        this.$refs['view-modal'].hide()
      }
    },
    created () {

    }
  }
</script>
